export const theme = {
  breakpoints: ['576px', '768px', '992px', '1200px', '1400px'],
  grid: {
    container: '130rem',
    gutter: '3.2rem',
  },
  border: {
    xsmallRadius: '4px',
    smallRadius: '8px',
    normal: '10px',
    mediumRadius: '16px',
    largeRadius: '24px',
  },
  font: {
    montserrat: 'Montserrat, sans-serif',
    sora: 'Sora',
    inter: 'Inter, sans-serif',
    workSans: 'Work Sans, sans-serif',
    light: 300,
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    sizes: {
      xxsmall: '0.625rem',
      xsmall: '0.75rem',
      small: '0.875rem',
      normal: '1rem',
      medium: '1.125rem',
      large: '1.25rem',
      xlarge: '1.5rem',
      xxlarge: '1.875rem',
      huge: '4rem',
    },
  },
  colors: {
    system: '#004CE8',
    black: '#000',
    white: '#fff',
    green1: '#046639',
    green2: '#0E9658',
    green3: '#66BC51',
    green4: '#45A752',
    green5: '#B4E08E',
    lightGreen: '#E0F6CC',
    boldGreen: '#014B29',
    boldGreen2: '#005A31',
    erro: '#FF3333',
    gray50: '#FAFAFA',
    gray100: '#F5F5F5',
    gray200: '#EEEEEE',
    gray300: '#E0E0E0',
    gray400: '#BDBDBD',
    gray500: '#9E9E9E',
    gray600: '#757575',
    gray700: '#616161',
    gray800: '#424242',
    gray900: '#212121',
    overlay: {
      primary: 'rgba(0,0,0,.4)',
    },
  },
  transition: {
    default: '0.2s ease-in-out',
    fast: '0.1s ease-in-out',
  },
}
